// Adds a wrapper component based on a condition; if condition
// is not present, no wrapper is added
export const ConditionalWrapper = ({ condition, wrapper, children }) => (
  condition ? wrapper(children) : children
)